// extracted by mini-css-extract-plugin
module.exports = {"disable-scroll":"learnervalidationuploadhistory_disable-scroll__2JIdV"};